import React, { useState, useCallback, useEffect } from 'react';
import { message } from 'antd';
import { useKeycloak } from '@react-keycloak/web';
import { useNavigate, useParams } from 'react-router-dom';
import { useNotifications } from '../contexts/NotificationContext';
import { useCollectionsData } from '../contexts/CollectionsDataContext';
import { createDataCollection } from '../services/api';
import CollectionsList from '../components/collections/CollectionsList';
import CollectionDetail from '../components/collections/CollectionDetail';
import CreateCollectionModal from '../components/collections/CreateCollectionModal';
import './DataCollections.css';

function DataCollectionsInner() {
    const { keycloak } = useKeycloak();
    const { addNotification } = useNotifications();
    const navigate = useNavigate();
    const { collectionId: collectionIdParam } = useParams();
    const { invalidateCollections, ensureCollections } = useCollectionsData();

    const [createModalVisible, setCreateModalVisible] = useState(false);

    useEffect(() => {
        if (collectionIdParam) return;
        try {
            if (sessionStorage.getItem('focusml:open-collection-create') === '1') {
                sessionStorage.removeItem('focusml:open-collection-create');
                setCreateModalVisible(true);
            }
        } catch (_) { /* storage unavailable */ }
    }, [collectionIdParam]);

    const openCollection = useCallback((collection) => {
        navigate(`/collections/${collection.public_id || collection.id}`);
    }, [navigate]);

    const goBack = useCallback(() => {
        navigate('/collections');
    }, [navigate]);

    const handleCreate = async (formData, name) => {
        await createDataCollection(keycloak, formData);
        message.success('Collection created!');
        addNotification({ type: 'success', title: 'Collection created', message: `${name} is ready to use`, status: 'completed', dismissible: true });
        setCreateModalVisible(false);
        invalidateCollections();
        await ensureCollections(true);
    };

    return (
        <div className="page-container">
            {collectionIdParam ? (
                <CollectionDetail collectionId={collectionIdParam} onBack={goBack} />
            ) : (
                <CollectionsList onOpenCollection={openCollection} onCreateNew={() => setCreateModalVisible(true)} />
            )}
            <CreateCollectionModal open={createModalVisible} onCancel={() => setCreateModalVisible(false)} onCreate={handleCreate} />
        </div>
    );
}

const DataCollections = () => <DataCollectionsInner />;

export default DataCollections;
